module.exports = __webpack_public_path__ + "img/ertiga-boostergreen-gls-plata-metalico.e3f2daee.png";